module.exports = __webpack_public_path__ + "img/AT0000002607388.b0f17f7c.png";